import React from "react";
import { IHistory } from "../../../store/credit/types";
import { toggle, groupByKey } from "../../../util/common";
import { useTranslation } from "react-i18next";

interface IProps {
    groupData: IHistory[] | undefined;
}

const CreditHistoryTwoYearPayment: React.FunctionComponent<IProps> = (props) => {
    const { t: tLang } = useTranslation();
    const renderData = (data: IHistory) => {
        var mygroupdata = groupByKey(data.monthlyHistoryList, "year");
        if (Object.keys(mygroupdata).length === 0) {
            return <tr className="hide-label">
                       <td role="cell" colspan="13">
                       </td>
                   </tr>
        }
        return (
            <React.Fragment>
                {Object.entries(mygroupdata).map(([key, val], index) => (
                    <tr key={"year-header-th" + index}>
                        <td className="table-label">
                            {key}
                        </td>
                        {showRowData(mygroupdata[key])}
                    </tr>
                ))}
            </React.Fragment>
        );
    };

    const showtd = (value: string) => {
        switch (value) {
            case "C":
                return (
                    <td className="col-width-icon text-align-center">
                        <div className="credit-report-payment-indicator status-good" title={tLang("credit.creditReport.tabs.creditSummarySection.creditHistorySection.twoYearPaymentHistorySection.zeroDaysPastDue")}>
                            <em className="las la-chevron-circle-up"></em>
                            <span className="sr-only">{tLang("credit.creditReport.tabs.creditSummarySection.creditHistorySection.twoYearPaymentHistorySection.zeroDaysPastDue")}</span>
                        </div>
                    </td>
                );
            case "1":
                return (
                    <td className="col-width-icon text-align-center">
                        <div className="credit-report-payment-indicator status-average" title={tLang("credit.creditReport.tabs.creditSummarySection.creditHistorySection.twoYearPaymentHistorySection.thirtyDaysPastDue")}>
                            <em className="las la-minus-circle"></em>
                            <span className="sr-only">{tLang("credit.creditReport.tabs.creditSummarySection.creditHistorySection.twoYearPaymentHistorySection.thirtyDaysPastDue")}</span>
                        </div>
                    </td>
                );
            case "2":
                return (
                    <td className="col-width-icon text-align-center">
                        <div className="credit-report-payment-indicator status-average" title={tLang("credit.creditReport.tabs.creditSummarySection.creditHistorySection.twoYearPaymentHistorySection.thirtyDaysPastDue")}>
                            <em className="las la-minus-circle"></em>
                            <span className="sr-only">{tLang("credit.creditReport.tabs.creditSummarySection.creditHistorySection.twoYearPaymentHistorySection.thirtyDaysPastDue")}</span>
                        </div>
                    </td>
                );
            case "3":
            case "4":
            case "5":
            case "6":
            case "7":
            case "8":
            case "9":
            case "10":
            case "11":
                return (
                    <td className="col-width-icon text-align-center">
                        <div className="credit-report-payment-indicator status-negative" title="Negative">
                            <em className="las la-chevron-circle-down"></em>
                            <span className="sr-only">{tLang("credit.creditReport.tabs.creditSummarySection.creditHistorySection.twoYearPaymentHistorySection.negative")}</span>
                        </div>
                    </td>
                );
            case " ":
                return (
                    <td className="col-width-icon text-align-center">
                        <div className="credit-report-payment-indicator status-unknown" title={tLang("credit.creditReport.tabs.creditSummarySection.creditHistorySection.twoYearPaymentHistorySection.unknown")}></div>
                    </td>
                );
            default:
                return (
                    <td className="col-width-icon text-align-center">
                        <div className="credit-report-payment-indicator status-unknown" title="Unknown"></div>
                    </td>
                );
        }
    };

    const showRowData = (values: any) => {
        if (values != null && values.length > 0 && values.length < 12) {
            var year = values[0].year;
            for (var i = 0; i < 12; i++) {
                var historydata = values.find((history: { month: number }) => history.month === i + 1);
                if (historydata == null) {
                    values.splice(i, 0, { year: year, month: i + 1, status: " " });
                }
            }
        }

        return (
            <React.Fragment>
                {values && values.map((score: any, index: number) => <React.Fragment key={"td_ty_" + index}>{showtd(score.status)}</React.Fragment>)}
            </React.Fragment>
        );
    };

    return (
        <React.Fragment>
            <div className="drawer-container">
                <div className="drawer-header">
                    <button
                        aria-expanded="false"
                        className="btn-default btn-toggle btn-drawer"
                        id="btn-payment-history"
                        onClick={() => toggle("payment-history", "btn-payment-history")}
                    >
                        <span className="btn-toggle-status sr-only">Show</span>
                        <span className="btn-text">{tLang("credit.creditReport.tabs.creditSummarySection.creditHistorySection.twoYearPaymentHistorySection.title")}</span>
                    </button>
                </div>

                <div className="drawer-content" id="payment-history">
                    <h3 className="sr-only">{tLang("credit.creditReport.tabs.creditSummarySection.creditHistorySection.twoYearPaymentHistorySection.title")}</h3>

                    <ul className="list-reset list-inline text-align-right" id="table-key">
                        <li>
                            <div className="credit-report-payment-indicator status-good" title={tLang(" credit.creditReport.tabs.creditSummarySection.creditHistorySection.twoYearPaymentHistorySection.zeroDaysPastDue")}>
                                <em className="las la-chevron-circle-up"></em>
                            </div>
                            <span>0</span>
                        </li>
                        <li>
                            <div className="credit-report-payment-indicator status-average">
                                <em className="las la-minus-circle"></em>
                            </div>
                            <span>30-60</span>
                        </li>
                        <li>
                            <div className="credit-report-payment-indicator status-negative">
                                <em className="las la-chevron-circle-down"></em>
                            </div>
                            <span>{tLang("credit.creditReport.tabs.creditSummarySection.creditHistorySection.twoYearPaymentHistorySection.negative")}</span>
                        </li>
                        <li>
                            <div className="credit-report-payment-indicator status-unknown" title={tLang("credit.creditReport.tabs.creditSummarySection.creditHistorySection.twoYearPaymentHistorySection.unknown")}></div>
                            <span>{tLang("credit.creditReport.tabs.creditSummarySection.creditHistorySection.twoYearPaymentHistorySection.unknown")}</span>
                        </li>
                    </ul>

                    {props.groupData &&
                        props.groupData.map((history: IHistory, index) => (
                            <React.Fragment key={"two-year" + index}>
                                <div className="margin-vertical-l"></div>
                                <div className="row between-xs margin-bottom-xs payment-table-header">
                                    <div className="col-xs flex-grow-null">
                                        <h4 className="content-table-title">{history.bureau}</h4>
                                    </div>
                                    <div className="col-xs flex-grow-null">
                                        <div className="credit-report-days-past-due">
                                            {tLang("credit.creditReport.tabs.creditSummarySection.creditHistorySection.twoYearPaymentHistorySection.daysPastDue")}: <strong>0</strong>
                                        </div>
                                    </div>
                                </div>
                                <div className="table-container scroll">
                                    <table className="m-table-generic table-payment-history">
                                        <caption className="sr-only">{tLang("credit.creditReport.tabs.creditSummarySection.creditHistorySection.twoYearPaymentHistorySection.subtitle")} {history.bureau}</caption>
                                        <thead>
                                            <tr>
                                                <th scope="col">{tLang("credit.creditReport.tabs.creditSummarySection.creditHistorySection.twoYearPaymentHistorySection.year")}</th>
                                                <th scope="col" className="col-width-icon text-align-center">
                                                    <abbr title="January">{tLang("credit.creditReport.tabs.creditSummarySection.creditHistorySection.twoYearPaymentHistorySection.jan")}</abbr>
                                                </th>
                                                <th scope="col" className="col-width-icon text-align-center">
                                                    <abbr title="February">{tLang("credit.creditReport.tabs.creditSummarySection.creditHistorySection.twoYearPaymentHistorySection.feb")}</abbr>
                                                </th>
                                                <th scope="col" className="col-width-icon text-align-center">
                                                    <abbr title="March">{tLang("credit.creditReport.tabs.creditSummarySection.creditHistorySection.twoYearPaymentHistorySection.mar")}</abbr>
                                                </th>
                                                <th scope="col" className="col-width-icon text-align-center">
                                                    <abbr title="April">{tLang("credit.creditReport.tabs.creditSummarySection.creditHistorySection.twoYearPaymentHistorySection.apr")}</abbr>
                                                </th>
                                                <th scope="col" className="col-width-icon text-align-center">
                                                    <abbr title="May">{tLang("credit.creditReport.tabs.creditSummarySection.creditHistorySection.twoYearPaymentHistorySection.may")}</abbr>
                                                </th>
                                                <th scope="col" className="col-width-icon text-align-center">
                                                    <abbr title="June">{tLang("credit.creditReport.tabs.creditSummarySection.creditHistorySection.twoYearPaymentHistorySection.jun")}</abbr>
                                                </th>
                                                <th scope="col" className="col-width-icon text-align-center">
                                                    <abbr title="July">{tLang("credit.creditReport.tabs.creditSummarySection.creditHistorySection.twoYearPaymentHistorySection.jul")}</abbr>
                                                </th>
                                                <th scope="col" className="col-width-icon text-align-center">
                                                    <abbr title="August">{tLang("credit.creditReport.tabs.creditSummarySection.creditHistorySection.twoYearPaymentHistorySection.aug")}</abbr>
                                                </th>
                                                <th scope="col" className="col-width-icon text-align-center">
                                                    <abbr title="September">{tLang("credit.creditReport.tabs.creditSummarySection.creditHistorySection.twoYearPaymentHistorySection.sep")}</abbr>
                                                </th>
                                                <th scope="col" className="col-width-icon text-align-center">
                                                    <abbr title="October">{tLang("credit.creditReport.tabs.creditSummarySection.creditHistorySection.twoYearPaymentHistorySection.oct")}</abbr>
                                                </th>
                                                <th scope="col" className="col-width-icon text-align-center">
                                                    <abbr title="November">{tLang("credit.creditReport.tabs.creditSummarySection.creditHistorySection.twoYearPaymentHistorySection.nov")}</abbr>
                                                </th>
                                                <th scope="col" className="col-width-icon text-align-center">
                                                    <abbr title="December">{tLang("credit.creditReport.tabs.creditSummarySection.creditHistorySection.twoYearPaymentHistorySection.dec")}</abbr>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>{renderData(history)}</tbody>
                                    </table>
                                </div>
                            </React.Fragment>
                        ))}
                </div>
            </div>
        </React.Fragment>
    );
};

export default CreditHistoryTwoYearPayment;
